import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ShareExpiredPage, isExpiredError } from "@/components/ShareExpiry";
import api from "@/lib/api";
import { MinutesView } from "@/components/le/MinutesView";

const font = { fontFamily: "Manrope, Inter, ui-sans-serif, system-ui, sans-serif" };

export default function PublicLeMeeting() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    const m1 = document.createElement("meta"); m1.name = "referrer"; m1.content = "no-referrer"; const m2 = document.createElement("meta"); m2.name = "robots"; m2.content = "noindex, nofollow"; document.head.append(m1, m2);
    return () => { m1.remove(); m2.remove(); };
  }, []);
  useEffect(() => {
    document.title = "BSM A/S — Ledelsens evaluering";
    const id = "gf-manrope";
    if (!document.getElementById(id)) {
      const l = document.createElement("link"); l.id = id; l.rel = "stylesheet";
      l.href = "https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&family=Inter:wght@400;500;600&display=swap";
      document.head.appendChild(l);
    }
    api.get(`/public/le/${token}`).then((r) => setData(r.data)).catch((e) => setErr(isExpiredError(e) ? "expired" : true));
  }, [token]);

  if (err === "expired") return <ShareExpiredPage />;
  if (err) return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-6" style={{ background: "#F3F1EC", ...font }} data-testid="pub-le-not-found">
      <p className="text-xs font-bold uppercase tracking-[0.2em]" style={{ color: "#A83232" }}>BSM A/S</p>
      <h1 className="text-3xl font-light mt-4" style={{ color: "#1A1919" }}>Dette referatlink er ikke længere aktivt.</h1>
      <p className="mt-3 max-w-md" style={{ color: "#A8A29E" }}>Kontakt BSM A/S for at få et opdateret link.</p>
    </div>
  );
  if (!data) return <div className="min-h-screen flex items-center justify-center" style={{ background: "#FBFAF8", color: "#A8A29E", ...font }}>Indlæser referat…</div>;
  return <MinutesView data={data} token={token} />;
}
